import { saveWorkspaceForm, getWorkspaceForm } from "../services/LocalStorage";
import { encryptForStorage, decryptFromStorage } from "./secureStorage";

export async function saveFormSecure(wsId, formState, passphrase) {
  const { appPassword, ...rest } = formState;
  let encryptedPassword = null;

  if (appPassword) {
    encryptedPassword = await encryptForStorage(appPassword, passphrase);
  }

  return saveWorkspaceForm(wsId, {
    ...rest,
    appPasswordEnc: encryptedPassword,
  });
}

export async function loadFormSecure(wsId, passphrase) {
  const raw = getWorkspaceForm(wsId, {});
  let appPassword = "";

  if (raw.appPasswordEnc && passphrase) {
    try {
      appPassword = await decryptFromStorage(raw.appPasswordEnc, passphrase);
    } catch {
      appPassword = "";
    }
  }
  return { ...raw, appPassword };
}
